import { app } from '../../app.module'
app
  // 投稿一覧に表示する、タグ一覧のディレクティブ
  .directive('postTableTagList', () => {
    return {
      restrict: 'E',
      template: require('./post-table-tag-list.pug')(),
      scope: {
        tags: '=tags',
        postId: '@postId',
        accountModalFlg: '=accountModalFlg',
      },
      controller: function ($rootScope, $scope, postTableTagListService, PostAction) {
        // グローバルタグの一覧が文字列になっているので、オブジェクトに変換する
        if ($scope.tags.globalTagIds !== null) {
          const globalTags: {}[] = postTableTagListService.Init.parseTags(
            $scope.tags.globalTagIds,
            $scope.tags.globalTagNames
          )

          $scope.globalTags = globalTags
        }

        // グループタグの一覧が文字列になっているので、オブジェクトに変換する
        if ($scope.tags.groupTagIds !== null) {
          const groupTags: {}[] = postTableTagListService.Init.parseTags(
            $scope.tags.groupTagIds,
            $scope.tags.groupTagNames
          )

          $scope.groupTags = groupTags
        }

        // ユーザータグの一覧が文字列になっているので、オブジェクトに変換する
        if ($scope.tags.userTagIds !== null) {
          const userTags: {}[] = postTableTagListService.Init.parseTags(
            $scope.tags.userTagIds,
            $scope.tags.userTagNames
          )

          $scope.userTags = userTags
        }

        /**
         * タグをクリックした場合はイベントを送信する
         * @param  {string} tagName クリックしたタグ名
         */
        $scope.searchTag = function (tagName: string) {
          // モーダルではない場合、タグクリックでフィルタリングを行う
          if (!$scope.accountModalFlg) {
            $rootScope.$broadcast('clickPostTableTag', tagName)
          }
        }

        // 変更のあったディレクティブのみイベント受信するため、投稿IDをイベント名に含める
        const eventName = 'changeTag_' + $scope.postId

        // モーダルにてタグが新規追加された場合、変更を反映する
        const removeEvent = $rootScope.$on(eventName, (event, data) => {
          // 投稿タグ一覧をリセット
          PostAction.tagLists = null
          // 投稿タグを更新
          switch (data.tagRole) {
            case 'global':
              $scope.globalTags = data.newTags
              break
            case 'group':
              $scope.groupTags = data.newTags
              break
            case 'user':
              $scope.userTags = data.newTags
              break
          }
        })

        // ディレクティブが消える際には、$rootScopeのイベントの監視を削除
        $scope.$on('$destroy', () => {
          removeEvent()
        })
      },
    }
  })
